<template>
  <div>
    <v-card class="pa-4 mx-2" flat>
      <v-card-title>
        <b> Dashboard </b>
      </v-card-title>
      <v-card-text class="card-text">
        Visualize todos os relatórios gerados pelos sistema conforme as datas
        que desejar.
      </v-card-text>
    </v-card>

    <v-card class="pa-4 mx-2" flat>
      <v-row class="ma-0" style="cursor: pointer" @click="filters = !filters">
        <v-col class="d-flex align-center" cols="12">
          <h3>{{ filters ? "Esconder" : "Mostrar" }} filtros</h3>
          <v-spacer></v-spacer>
          <v-btn icon large>
            <v-icon>{{
              filters ? "mdi-chevron-up" : "mdi-chevron-down"
            }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-expand-transition>
        <v-row v-if="filters" class="ma-0">
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12">
            <b> Período </b>
          </v-col>

          <v-col
              cols="12"
              xs="12"
              sm="12"
              md="12"
              lg="4"
              xl="4"
          >
            <v-text-field
              v-model="filter.startDate"
              clearable
              outlined
              dense
              height="41"
              label="Data de início"
              type="date"
            ></v-text-field>
          </v-col>

          <v-col
              cols="12"
              xs="12"
              sm="12"
              md="12"
              lg="4"
              xl="4"
          >
            <v-text-field
              v-model="filter.endDate"
              clearable
              outlined
              dense
              height="41"
              label="Data de término"
              type="date"
            ></v-text-field>
          </v-col>

          <v-col
              cols="12"
              xs="12"
              sm="12"
              md="12"
              lg="4"
              xl="4"
          >
            <v-btn outlined class="" @click="reset">Limpar filtros</v-btn>
            <v-btn outlined class="ml-3" @click="filtrate"> Filtrar </v-btn>
          </v-col>
        </v-row>
      </v-expand-transition>
    </v-card>

    <v-card elevation="0" class="mx-2" color="transparent">
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="4" lg="3" xl="3" >
          <v-card flat class="text-center pa-4">
            <v-progress-circular
              indeterminate
              v-if="loading"
            ></v-progress-circular>
            <div v-else>
              <strong>Aprovado</strong>
              <h2>
                {{numberOrdersApproved}}
              </h2>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="4" lg="3" xl="3" >
          <v-card flat class="text-center pa-4">
            <v-progress-circular
              indeterminate
              v-if="loading"
            ></v-progress-circular>
            <div v-else>
              <strong>Faturado</strong>
              <h2>
                {{numberOrdersBilled}}
              </h2>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="4" lg="3" xl="3" >
          <v-card flat class="text-center pa-4">
            <v-progress-circular
              indeterminate
              v-if="loading"
            ></v-progress-circular>
            <div v-else>
              <strong>Entregue</strong>
              <h2>
                {{numberOrdersDelivered}}
              </h2>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="4" lg="3" xl="3" >
          <v-card flat class="text-center pa-4">
            <v-progress-circular
              indeterminate
              v-if="loading"
            ></v-progress-circular>
            <div v-else>
              <strong>Cancelado</strong>
              <h2>
                {{numberOrdersCanceled}}
              </h2>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <v-card flat class="text-center pa-4">
            <v-progress-circular
              indeterminate
              v-if="loading"
            ></v-progress-circular>
            <div v-else>
              <strong>Valor disponível</strong>
              <h2>
                {{
                  (
                    Number(resellerBalance.available_amount) / 100
                  ).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </h2>
            </div>
          </v-card>
        </v-col>

        <v-col sm="4">
          <v-card flat class="text-center pa-4">
            <v-progress-circular
              indeterminate
              v-if="loading"
            ></v-progress-circular>
            <div v-else>
              <strong>Valor transferido</strong>
              <h2>
                {{
                  (
                    Number(resellerBalance.transferred_amount) / 100
                  ).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </h2>
            </div>
          </v-card>
        </v-col>

        <v-col sm="4">
          <v-card flat class="text-center pa-4">
            <v-progress-circular
              indeterminate
              v-if="loading"
            ></v-progress-circular>
            <div v-else>
              <strong>Valor a receber</strong>
              <h2>
                {{
                  (
                    Number(resellerBalance.waiting_funds_amount) / 100
                  ).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </h2>
            </div>
          </v-card>
        </v-col>

        <v-col sm="6">
          <v-card flat class="text-center pa-4">
            <v-progress-circular
              indeterminate
              v-if="loading"
            ></v-progress-circular>
            <div v-else>
              <strong>Quantidade de vendas</strong>
              <h2>{{ salesQuantity }}</h2>
            </div>
          </v-card>
        </v-col>

        <v-col sm="6">
          <v-card flat class="text-center pa-4">
            <v-progress-circular
              indeterminate
              v-if="loading"
            ></v-progress-circular>
            <div v-else>
              <strong>Valor de vendas</strong>
              <h2>
                {{
                  salesValue.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </h2>
            </div>
          </v-card>
        </v-col>

        <v-col md="12">
          <ReceiptReports :filter.sync="filter" ref="receiptReports" />
        </v-col>

        <v-col md="6">
          <Products :filter.sync="filter" ref="product" />
        </v-col>

        <v-col md="6">
          <Skus :filter.sync="filter" ref="skus" />
        </v-col>

        <v-col md="6">
          <Categories :filter.sync="filter" ref="categories" />
        </v-col>

        <v-col md="6">
          <Cities :filter.sync="filter" ref="cities" />
        </v-col>

        <v-col md="6">
          <States :filter.sync="filter" ref="states" />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import ApiService from "../../../services/ApiService";
import moment from "moment";
import ReceiptReports from "./components/receiptReports.vue";
import Products from "./components/products.vue";
import Skus from "./components/skus.vue";
import Categories from "./components/categories.vue";
import Cities from "./components/cities.vue";
import States from "./components/states.vue";

export default {
  components: {
    ReceiptReports,
    Products,
    Skus,
    Categories,
    Cities,
    States,
  },

  data() {
    return {
      salesQuantity: 0,
      salesValue: 0,
      citiesPageCount: 1,
      numberOrdersApproved: 0,
      numberOrdersBilled: 0,
      numberOrdersDelivered: 0,
      numberOrdersCanceled: 0,
      filter: {
        page: 1,
        pageSize: 10,
        resaleId: "",
        startDate: "",
        endDate: "",
      },

      citiesHeaders: [
        {
          text: "Município",
          align: "center",
          value: "city",
        },
        {
          text: "Quantidade",
          align: "center",
          value: "salesQuantity",
          sortable: false,
        },
      ],
      headerProps: {
        sortByText: "Ordenar por",
      },
      loading: false,
      filters: true,
      apiService: new ApiService(),
      states: [],
      cities: ["Rio de Janeiro", "São Paulo"],
      countries: ["Brasil", "Argentina", "Chile"],
      resales: [],
      resellerBalance: {
        available_amount: 0,
        transferred_amount: 0,
        waiting_funds_amount: 0,
      },
    };
  },

  created() {
    this.filter.startDate = moment(new Date()).clone().startOf("month").format("YYYY-MM-DD");
    this.filter.endDate = moment(new Date()).clone().endOf("month").format("YYYY-MM-DD");
    this.filter.resaleId = JSON.parse(localStorage.getItem("user")).id;

    this.getSales();
    this.balance();
    this.ordersPlaced();
    this.operations();
  },

  methods: {
    filtrate() {
      this.getSales();
      this.$refs.product.getProductSales();
      this.$refs.skus.getSkuSales();
      this.$refs.categories.getCategorySales();
      this.$refs.cities.getCitiesSales();
      this.$refs.states.getStateSales();
      this.$refs.states.getStateSales();
      this.$refs.receiptReports.getRransactionSummary();
    },

    async ordersPlaced() {
      await this.apiService
          .post(`order/orders-resale-Status`, this.filter)
          .then((orders) => {
             const {content} = orders;
             const {numberOrdersApproved, numberOrdersBilled, numberOrdersDelivered, numberOrdersCanceled} = content;
            this.numberOrdersApproved = numberOrdersApproved;
            this.numberOrdersBilled = numberOrdersBilled;
            this.numberOrdersDelivered = numberOrdersDelivered;
            this.numberOrdersCanceled = numberOrdersCanceled;
          });
    },

    async balance() {
      await this.apiService
        .get(`resale/balance?resaleId=` + this.filter.resaleId)
        .then((balance) => {
          const { content } = balance;
          if (content) {
            this.resellerBalance = content;
          }
        });
    },

    reset() {
      this.filter = {
        startDate: "",
        endDate: "",
        resaleId: "",
      };
      this.filter.resaleId = JSON.parse(localStorage.getItem("user")).id;
    },

    getSales() {
      this.loading = true;
      this.apiService
        .post("dashresale/sales", this.filter)
        .then((response) => {
          this.salesQuantity = response.content.salesQuantity;
          this.salesValue = response.content.salesValue;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
